<form>
  <h1 mat-dialog-title>
    {{ (isUpdateTrans? 'Contribute.lblEditTransaction': 'Contribute.lblNewTransaction') | translate }}
  </h1>
  <div class="container">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thIdentifier' | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'Contribute.thIdentifier' | translate}}" maxlength="105" [(ngModel)]="transaction.identifier" [ngModelOptions]="{standalone: true}" required [disabled]="isNew == false" [readonly]="isNew == false" />
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thCpSector' | translate}}</mat-label>
            <mat-select [(ngModel)]="transaction.counterParty" [ngModelOptions]="{standalone: true}" required>
              @for (liItem of listItems.cpSectorList; track liItem) {
                <mat-option [value]="liItem">{{liItem}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thStatus' | translate}}</mat-label>
            <mat-select [value]="transaction.status" disabled>
              @for (liItem of listItems.statusList; track liItem) {
                <mat-option [value]="liItem">{{liItem}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="row" style="margin: 0;">
            <mat-form-field class="col-6">
              <mat-label>{{'Contribute.thInstrumentType' | translate}}</mat-label>
              <mat-select [(ngModel)]="transaction.instrumentType" [ngModelOptions]="{standalone: true}" required>
                @for (liItem of listItems.instrumentTypeList; track liItem) {
                  <mat-option [value]="liItem">{{liItem}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-6">
              <mat-label>{{'Contribute.thType' | translate}}</mat-label>
              <mat-select [(ngModel)]="transaction.type" [ngModelOptions]="{standalone: true}" required>
                @for (liItem of listItems.typeList; track liItem) {
                  <mat-option [value]="liItem">{{liItem}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thCurrency' | translate}}</mat-label>
            <mat-select [(ngModel)]="transaction.currency.id" [ngModelOptions]="{standalone: true}" required>
              @for (liItem of listItems.currencyList; track liItem) {
                <mat-option [value]="liItem.id">{{liItem.value}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thTradeDate' | translate}}</mat-label>
            <input matInput [matDatepicker]="dp1" readonly [(ngModel)]="transaction.tradeDate" [ngModelOptions]="{standalone: true}">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1 disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thSettlementDate' | translate}}</mat-label>
            <input matInput [matDatepicker]="dp2" readonly [(ngModel)]="transaction.settlementDate" [ngModelOptions]="{standalone: true}">
            <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
            <mat-datepicker #dp2 disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thMaturityDate' | translate}}</mat-label>
            <input matInput [matDatepicker]="dp3" readonly [(ngModel)]="transaction.maturityDate" [ngModelOptions]="{standalone: true}">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3 disabled="false"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thNomAmount' | translate}}</mat-label>
            <input type="number" matInput placeholder="{{'Contribute.thNomAmount' | translate}}" min="1" [(ngModel)]="transaction.nominalAmount" [ngModelOptions]="{standalone: true}" required />
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thRate' | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'Contribute.thRate' | translate}}" maxlength="9" [(ngModel)]="transaction.rate" [ngModelOptions]="{standalone: true}" required />
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Contribute.thComments' | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'Contribute.thComments' | translate}}" [(ngModel)]="transaction.comments" [ngModelOptions]="{standalone: true}" />
          </mat-form-field>
        </div>
      </div>
      <div mat-dialog-actions class="mb-1">
        <button mat-raised-button color="primary" (click)="onSaveTransaction()">{{'btnOk' | translate}}</button>&nbsp;
        <button mat-raised-button color="secondary" (click)="onCancel()">{{'btnCancel' | translate}}</button>
      </div>
    </div>
  </div>
</form>
